/* ---------------------------------------------------------------------------------------------------------------------
   LENUMA MENGEN-SCHALTER
   ---------------------------------------------------------------------------------------------------------------------
   Macht aus dem Mengenfeld einer Warenkorb-Position einen Schalter mit Minus
   und Plus.

   Die Warenkorb-Logik des Themes bleibt unangetastet: line-item-quantity hoert
   auf das change-Ereignis des Feldes und schickt die Aenderung selbst an
   Shopify. Hier wird nur der Wert gesetzt und change ausgeloest.

   Ein einziger delegierter Listener am Dokument. Damit funktionieren auch
   Positionen, die der Drawer nach jeder Aenderung neu zeichnet.
   --------------------------------------------------------------------------------------------------------------------- */

(function () {
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-lenuma-qty]');
    if (!button) return;

    const wrapper = button.closest('line-item-quantity');
    const input = wrapper && wrapper.querySelector('.quantity-input');
    if (!input) return;

    event.preventDefault();

    const step = parseInt(input.step, 10) || 1;
    const min = parseInt(input.min, 10) || 1;
    const max = input.max ? parseInt(input.max, 10) : Infinity;
    const current = parseInt(input.value, 10) || min;

    const direction = button.getAttribute('data-lenuma-qty') === '+' ? 1 : -1;
    let next = current + step * direction;

    /* Bewusst bei der Mindestmenge gestoppt statt auf 0 zu gehen: zum
       Entfernen gibt es das Papierkorb-Zeichen. Ein Minus, das beim letzten
       Stueck die Position loescht, trifft man zu leicht aus Versehen. */
    if (next < min) next = min;
    if (next > max) next = max;
    if (next === current) return;

    /* Das Mengenfeld des Themes ist ein eigenes Element mit einer
       quantity-Eigenschaft. Die mitzusetzen haelt seine Anzeige synchron. */
    if ('quantity' in input) {
      input.quantity = next;
    }
    input.value = String(next);

    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
